import React, { createContext, useContext, useState, useCallback } from 'react';

export type I3ModalId = 'marriage' | 'leadership' | 'financial' | 'speaking' | 'founders' | null;

type I3ModalContextValue = {
  modalId: I3ModalId;
  openModal: (id: Exclude<I3ModalId, null>) => void;
  closeModal: () => void;
};

const Context = createContext<I3ModalContextValue | null>(null);

export const I3ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [modalId, setModalId] = useState<I3ModalId>(null);

  const openModal = useCallback((id: Exclude<I3ModalId, null>) => {
    setModalId(id);
  }, []);

  const closeModal = useCallback(() => {
    setModalId(null);
  }, []);

  return (
    <Context.Provider value={{ modalId, openModal, closeModal }}>
      {children}
    </Context.Provider>
  );
};

export function useI3Modal(): I3ModalContextValue {
  const ctx = useContext(Context);
  if (!ctx) throw new Error('useI3Modal must be used within I3ModalProvider');
  return ctx;
}
